export type InboxRoute =
  | "/attention"
  | "/inbox"
  | "/records"
  | "/reports"
  | "/settings/notifications"
  | "/settings/plan"
  | "/settings/privacy"
  | "/setup"
  | "/tasks"
  | "/team";

export type InboxTarget =
  | { href: string; kind: "href" }
  | { kind: "route"; search: Record<string, string>; to: InboxRoute }
  | null;

const ID = /^[A-Za-z0-9][A-Za-z0-9-]{0,63}$/;

function route(
  to: InboxRoute,
  search: Record<string, string> = {},
): InboxTarget {
  return { kind: "route", search, to };
}

const webPaths: Record<string, InboxRoute> = {
  "/attention": "/attention",
  "/billing": "/settings/plan",
  "/inbox": "/inbox",
  "/privacy": "/settings/privacy",
  "/records": "/records",
  // "Your report is ready" links /reports?job=<id> (RDY-BE-26).
  "/reports": "/reports",
  "/settings": "/settings/notifications",
  "/setup": "/setup",
  "/tasks": "/tasks",
  "/team": "/team",
};

function fromNativeLink(link: string): InboxTarget {
  const segments = link.slice("safeplate://".length).split("/").filter(Boolean);
  const [kind, second, third] = segments;
  if (kind === "notifications" && segments.length === 1) return route("/inbox");
  if (kind === "follow-ups" && second && ID.test(second) && !third) {
    return route("/attention", { item: second });
  }
  if (kind === "tasks" && second && ID.test(second) && !third) {
    return route("/tasks", { definition: second });
  }
  if (kind === "renewals" && second && ID.test(second) && !third) {
    return route("/setup", { renewal: second, section: "documents" });
  }
  if (
    kind === "training" &&
    second === "assignments" &&
    third &&
    ID.test(third) &&
    segments.length === 3
  ) {
    return route("/team", { assignment: third, view: "training" });
  }
  return null;
}

function fromWebPath(link: string): InboxTarget {
  const [path = "", query = ""] = link.split("?", 2);
  const mapped = webPaths[path.replace(/\/+$/, "")];
  if (!mapped) return { href: link, kind: "href" };
  const search: Record<string, string> = {};
  for (const [key, value] of new URLSearchParams(query)) search[key] = value;
  return route(mapped, search);
}

export function inboxTarget(deepLink: string | null): InboxTarget {
  if (!deepLink) return null;
  if (deepLink.startsWith("safeplate://")) return fromNativeLink(deepLink);
  if (deepLink.startsWith("/") && !deepLink.startsWith("//")) {
    return fromWebPath(deepLink);
  }
  return null;
}
